import { APIRuntimeBuilder } from '@cian/mf-registry/browser';

import { TDispatch, TReduxStore } from '../../../shared/types/redux';
import { setDatesPopupOpen, setAllFiltersModalOpen } from 'shared/slices/modal';
// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { IJsonQueryPolygon } from 'packages/api-models/common/json_query';
import { removePolygon, selectPolygon } from 'shared/thunks/geo/polygon';
import { openGeoModal } from 'shared/slices/geo/slice';
import { setTagsHidden } from 'shared/slices/tags';
import { applyJsonQuery } from 'shared/thunks/jsonQuery';
import { TJsonQuery } from '../../../packages/JsonQuery';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v1/open-all-filters-modal',
      handler: async () => (store.dispatch as TDispatch)(setAllFiltersModalOpen(true)),
    },
    {
      path: '/v1/close-all-filters-modal',
      handler: async () => (store.dispatch as TDispatch)(setAllFiltersModalOpen(false)),
    },
    {
      path: '/v1/add-polygon-filter',
      handler: async (polygon: IJsonQueryPolygon) => (store.dispatch as TDispatch)(selectPolygon(polygon)),
    },
    {
      path: '/v1/remove-polygon-filter',
      handler: async () => (store.dispatch as TDispatch)(removePolygon()),
    },
    {
      path: '/v1/open-geo-modal',
      handler: async () => (store.dispatch as TDispatch)(openGeoModal()),
    },
    {
      path: '/v1/open-dates-popup',
      handler: async () => (store.dispatch as TDispatch)(setDatesPopupOpen(true)),
    },
    {
      path: '/v1/set-json-query',
      handler: async (jsonQuery: TJsonQuery) => (store.dispatch as TDispatch)(applyJsonQuery(jsonQuery)),
    },
    {
      path: '/v1/show-tags',
      handler: async () => (store.dispatch as TDispatch)(setTagsHidden(false)),
    },
    {
      path: '/v1/hide-tags',
      handler: async () => (store.dispatch as TDispatch)(setTagsHidden(true)),
    },
  ];
}
